<template>
  <div>
    <ckeditor
      :editor="editorInstance"
      :config="editorConfig"
      v-bind="$attrs"
      v-on="$listeners"
      @ready="onEditorReady"
    ></ckeditor>
  </div>
</template>

<script>
import CKEditor from '@ckeditor/ckeditor5-vue2';
import { ClassicEditor } from "@ckeditor/ckeditor5-editor-classic";
import Alignment from "@ckeditor/ckeditor5-alignment/src/alignment";
import Autoformat from "@ckeditor/ckeditor5-autoformat/src/autoformat";
import BlockQuote from "@ckeditor/ckeditor5-block-quote/src/blockquote";
import Essentials from "@ckeditor/ckeditor5-essentials/src/essentials";
import Font from "@ckeditor/ckeditor5-font/src/font";
import Heading from "@ckeditor/ckeditor5-heading/src/heading";
import Highlight from "@ckeditor/ckeditor5-highlight/src/highlight";
import HorizontalLine from "@ckeditor/ckeditor5-horizontal-line/src/horizontalline";
import Link from "@ckeditor/ckeditor5-link/src/link";
import List from "@ckeditor/ckeditor5-list/src/list";
import PageBreak from "@ckeditor/ckeditor5-page-break/src/pagebreak";
import Paragraph from "@ckeditor/ckeditor5-paragraph/src/paragraph";
import PasteFromOffice from "@ckeditor/ckeditor5-paste-from-office/src/pastefromoffice";
import SelectAll from "@ckeditor/ckeditor5-select-all/src/selectall";
import ShowBlocks from "@ckeditor/ckeditor5-show-blocks/src/showblocks";
import { SpecialCharacters, SpecialCharactersEssentials } from '@ckeditor/ckeditor5-special-characters';
import Table from "@ckeditor/ckeditor5-table/src/table";
import Typing from "@ckeditor/ckeditor5-typing/src/typing";
import { Indent } from "@ckeditor/ckeditor5-indent";
import { Image, ImageInsertViaUrl } from '@ckeditor/ckeditor5-image';
import {
  Bold,
  Code,
  Italic,
  Strikethrough,
  Subscript,
  Superscript,
  Underline,
} from "@ckeditor/ckeditor5-basic-styles";


const emoticons = [
  { title: "Smiley", character: "😊" },
  { title: "Sad", character: "😢" },
  { title: "Wink", character: "😉" },
  { title: "Laugh", character: "😄" },
  { title: "Frown", character: "😞" },
  { title: "Cheeky", character: "😏" },
  { title: "Blush", character: "😊" },
  { title: "Surprise", character: "😮" },
  { title: "Indecision", character: "😕" },
  { title: "Angry", character: "😠" },
  { title: "Angel", character: "😇" },
  { title: "Cool", character: "😎" },
  { title: "Devil", character: "😈" },
  { title: "Crying", character: "😢" },
  { title: "Enlightened", character: "💡" },
  { title: "Thumbs Up", character: "👍" },
  { title: "Thumbs Down", character: "👎" },
  { title: "Heart", character: "❤️" },
  { title: "Broken Heart", character: "💔" },
  { title: "Kiss", character: "💋" },
  { title: "Mail", character: "✉️" },
];

const editorConfig = {
  plugins: [
    Alignment,
    Autoformat,
    BlockQuote,
    Essentials,
    Font,
    Heading,
    Highlight,
    HorizontalLine,
    Indent,
    Link,
    List,
    PageBreak,
    Paragraph,
    PasteFromOffice,
    SelectAll,
    ShowBlocks,
    SpecialCharacters,
    SpecialCharactersEssentials,
    Table,
    Typing,
    Bold,
    Italic,
    Underline,
    Strikethrough,
    Code,
    Subscript,
    Superscript,
    Image,
    ImageInsertViaUrl,
  ],
  toolbar: {
    shouldNotGroupWhenFull: true,
    items: [
      "undo",
      "redo",
      '|',
      "bold",
      "italic",
      "underline",
      "strikethrough",
      "subscript",
      "superscript",
      "link",
      '|',
      "bulletedList",
      "numberedList",
      "outdent",
      "indent",
      '|',
      "blockQuote",
      '|',
      'alignment:left', 'alignment:right', 'alignment:center', 'alignment:justify',
      '|',
      "insertTable",
      "heading",
      '|',
      "selectAll",
      "showBlocks",
      "fontSize",
      "fontColor",
      "fontBackgroundColor",
      "highlight",
      "horizontalLine",
      "insertImage",
      "pageBreak",
      "specialCharacters",
    ],
  },
  image: {
    toolbar: [],
    types: ['url'],
  },
  language: "en",
  table: {
    contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"],
  },
  indentBlock: {
    offset: 1,
    unit: "em",
  },
  contentStyle: {
    'direction': 'ltr',
  },
};

export default {
  components: {
    ckeditor: CKEditor.component
  },

  props: {
    placeholder: String
  },

  data() {
    return {
      emoticons,
      editorConfig: {
          ...editorConfig,
          placeholder: this.placeholder,
        },
      editorInstance: ClassicEditor,
    };
  },
  methods: {
    onEditorReady(editor) {
      this.addCustomSpecialCharacters(editor);
    },
    addCustomSpecialCharacters(editor) {
      if (editor) {
        editor.plugins.get("SpecialCharacters").addItems("Emotes", this.emoticons);
      }
    },
  },
};
</script>

<style lang="scss">
.ck-editor__editable_inline:not(.ck-comment__input *) {
  height: 300px;
  overflow-y: auto;
}

// fix no bullet icon and indentation problem
.ck-content ul {
  list-style-type: disc;
  padding: revert;
}

//fix italic overighting Overwrite
.ck-editor__main {

  em,
  i {
    font-style: revert;
  }
}

//fix rick editor label showing 
label#ck-editor__label {
  display: none;
}
</style>
